
import ImageCompare from "image-compare-viewer";

//comparison slider

const element = document.getElementById("image-compare");
const options = {
  hoverStart: true,
  controlColor: "#FEC93A",
  controlShadow: false,
  addCircle: true,
  addCircleBlur: true,
  startingPoint: 50
}

if (element) {
  const viewer = new ImageCompare(element, options).mount();
}


//Play Video

let videoItem = document.querySelectorAll('.video__container')

videoItem.forEach((item) => {
  const videoPlay = item.querySelector('.video__play')
  const videoTarget = item.querySelector('.video__inner video')
  
  item.addEventListener('click', () => {
    if (videoTarget.paused) {
      videoTarget.play()
      videoPlay.classList.add('pause')
    } else {
      videoTarget.pause()
      videoPlay.classList.remove('pause')
    }
  })
});


//Intersection Observer


const intersectionTarget = document.querySelectorAll('.check-viewport');

let observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-viewport');
    }
  });
});

intersectionTarget.forEach(item => {
  observer.observe(item);
});


//Swiper
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const swiper = new Swiper('.slider__swiper-container', {
  // Optional parameters
  // loop: true,
  slidesPerView: 'auto',
  
  // Navigation arrows
  navigation: {
    nextEl: '.slider__next',
    prevEl: '.slider__prev',
  },
});

//Nav

const navToggle = document.querySelector('.nav-toggle')
const navClose = document.querySelector('.nav__close')
const nav = document.querySelector('.nav')

navToggle.addEventListener('click', () => {
  nav.classList.add('nav--open')
})

navClose.addEventListener('click', () => {
  nav.classList.remove('nav--open')
})


//Form

const inputField = document.querySelectorAll('.input-group')

inputField.forEach((el) => {
  const elInput = el.querySelector('input')
  const elLabel = el.querySelector('label')

  elInput.addEventListener('focus', () => {
    elLabel.classList.add('active')
    // console.dir(elInput)
  })
  
  elInput.addEventListener('blur', () => {
    if (!elInput.value) {
      elLabel.classList.remove('active')
    }
  })
})